import { SxProps, Theme } from "@mui/material";

export const availabilityScreenStyles = {
  container: {
    p: "1rem",
  },
  loadingContainer: {
    height: "90vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  emptyText: {
    fontSize: "16px",
    fontWeight: "400",
    textAlign: "left",
    marginTop: "15px",
  },
  card: (theme: Theme): SxProps<Theme> => ({
    borderRadius: "10px",
    cursor: "pointer",
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down("sm")]: {
      width: "350px",
    },
  }),
  imageBox: {
    borderRadius: "8px",
  },
  image: {
    width: "100%",
    height: "229px",
    objectFit: "cover" as const,
    display: "block",
    borderRadius: "8px 8px 0px 0px",
  },
  titleText: {
    color: "#000",
    fontSize: "22px",
    fontWeight: 600,
  },
  subtitleText: {
    color: "#000",
    fontSize: "17px",
    fontWeight: 400,
    paddingBottom: "10px",
  },
  detailContainer: {
    paddingY: "10px",
    gap: "2px",
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  rowContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  timeContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: "8px",
  },
  rowText: {
    color: "#000",
    fontSize: "20px",
    fontWeight: "500",
    marginRight: "5px",
    lineHeight: "26px",
    letterSpacing: 0.074,
  },
  dotText: {
    paddingHorizontal: "7px",
  },
  pencilIcon: {
    marginLeft: "12px",
  },
  iconContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  shareIcon: {
    marginRight: "10px",
  },
  secondRowContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: "5px",
  },

  priceContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    gap: "40px",
    flex: 1,
    alignItems: "center",
  },
  priceSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  priceLabel: {
    color: "#000",
    fontSize: "17px",
    fontWeight: "600",
    marginRight: "5px",
    whiteSpace: "nowrap",
  },
  priceValue: {
    color: "#000",
    fontSize: "17px",
    fontWeight: "400",
    wordBreak: "break-word",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: 135,
  },
  availabilityBadge: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: "12px",
    borderColor: "#00954A",
    border: "1px solid #00954A",
    paddingY: "2px",
    paddingX: "12px",
  },
  availabilityText: {
    color: "#000",
    fontSize: "11px",
    fontWeight: "400",
    // textWrap: 'nowrap'
  },

  // FH card styles:
  headerRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    paddingTop: "7px",
  },
  titleTextFareharbor: {
    width: "86%",
    fontSize: "22px",
    fontWeght: "600",
  },
  fareharborIcon: {
    marginRight: "10px",
    marginTop: "2px",
  },
  availabilityCardBox: (isScreenBreak: boolean) => ({
    display: "flex",
    width: "100%",
    flexDirection: "row",
    marginTop: 3,
    flexWrap: "wrap",
    justifyContent: isScreenBreak ? "center" : "flex-start",
    gap: "20px",
  }),
  customerDetailsText: {
    fontSize: "15px",
    color: "#000",
    fontWeight: "400",
  },
  boldText: {
    fontWeight: "600",
  },
};
